'use client';

import {Link} from '@components/@nav';
import classNames from 'classnames';
import {ComponentProps, FC} from 'react';
import {MeinSpinner} from '..';
import styles from './MeinButton.module.css';

type BaseProps = {
    isLoading?: boolean;
    variant?:
        | 'filled'
        | 'outlined'
        | 'text'
        | 'elevated'
        | 'tonal'
        | 'filledWhite'
        | 'ghost'
        | 'destructive';
    size?: 'small' | 'medium';
    containerClassName?: string;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    fullWidth?: boolean;
};

type ButtonProps = BaseProps & ComponentProps<'button'> & {tag?: 'button'};
type AnchorProps = BaseProps & ComponentProps<'a'> & {tag: 'a'};
type LinkProps = BaseProps & ComponentProps<typeof Link> & {tag: 'link'};
type DivProps = BaseProps & ComponentProps<'div'> & {tag: 'div'};

export type MeinButtonProps = ButtonProps | AnchorProps | DivProps | LinkProps;

// @todo: refactor to use ChildrenDecorator Component
export const MeinButton: FC<MeinButtonProps> = ({
    children,
    isLoading,
    disabled,
    className,
    containerClassName,
    variant = 'filled',
    size = 'medium',
    tag = 'button',
    type = 'button',
    fullWidth,
    ...rest
}) => {
    let Tag = tag as 'button';

    if (tag === 'link') {
        Tag = Link as unknown as 'button';
    }

    return (
        <Tag
            className={classNames(
                styles.button,
                styles[size],
                styles[variant],
                {
                    [styles.loading]: isLoading,
                    [styles.disabled]: disabled,
                    [styles.fullWidth]: fullWidth,
                },

                className,
            )}
            {...(tag === 'button' && {
                disabled: disabled || isLoading,
                type,
            })}
            {...(rest as ComponentProps<typeof Tag>)}
        >
            <span
                className={classNames(
                    styles.buttonInner,
                    {
                        [styles.buttonInnerHidden]: isLoading,
                    },
                    containerClassName,
                )}
            >
                {children}
            </span>
            {isLoading && (
                <div className={styles.spinnerContainer}>
                    <MeinSpinner size="s" className={styles.spinner} />
                </div>
            )}
        </Tag>
    );
};
